import _ from 'lodash'
import React, { memo } from 'react'
import {
  Container,
  Message,
  Table,
  Button,
  Loader,
  Dimmer
} from 'semantic-ui-react'
import { formLabels, referrerLabels, requestLabels } from './labels'
import { pacsLabel } from './optionsData'

const styles = {
  reviewContainer: {
    marginTop: '4em',
    paddingBottom: '1em'
  }
}

const formatDate = date =>
  `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`

const PostedMessage = props => {
  const { formState, handleReset } = props
  const { emailAddress } = formState.values.referrer

  return (
    <Message success>
      <Message.Header>Request Submitted</Message.Header>
      <p>
        A confirmation email will be sent to <strong>{emailAddress}</strong>{' '}
        once the request has been processed.
      </p>

      <Button basic onClick={handleReset}>
        Submit another request
      </Button>
    </Message>
  )
}

export const Review = memo(props => {
  const {
    formState,
    setFormState,
    handleReset,
    handlePost,
    sourceBusinessUnit
  } = props
  const { posted, error, posting } = formState

  const renderValuesColumn = (key, value) => {
    return key.includes('studyDates')
      ? value.allDates === 'true'
        ? 'All dates'
        : `${formatDate(new Date(value.startDate))} - ${formatDate(
            new Date(value.endDate)
          )}`
      : key.includes('requestingInstitution') && value
      ? pacsLabel(sourceBusinessUnit, JSON.parse(value).hospital)
      : key.includes('dob')
      ? formatDate(new Date(value))
      : key.includes('useInteleViewer')
      ? value
        ? 'Yes'
        : requestLabels.useWachs
      : key.includes('businessUnit')
      ? sourceBusinessUnit
      : key === 'urgent'
      ? value
        ? 'Yes'
        : 'No'
      : typeof value === 'string'
      ? value
      : _.capitalize(JSON.stringify(value))
  }

  return (
    <Container text style={styles.reviewContainer}>
      {posting ? (
        <Loader active inline='centered'>
          Submitting request. Do not close this window.
        </Loader>
      ) : posted ? (
        <PostedMessage {...{ formState, handleReset }} />
      ) : (
        <Container text textAlign={'center'} style={{ margin: '2em' }}>
          <p>Please review the details below before submitting.</p>
          <Button.Group size='huge'>
            <Button positive onClick={handlePost}>
              Request transfer
            </Button>
            <Button.Or />
            <Button
              onClick={() => {
                setFormState(state => ({ ...state, submitted: false }))
              }}
            >
              Correct details
            </Button>
          </Button.Group>
          {error && (
            <Message error>
              Sorry, your request could not be submitted. Please try again
              later.
            </Message>
          )}
        </Container>
      )}
      <Table celled striped attached color='blue' inverted>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan='2'>Referrer details</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Object.entries(formState.values.referrer).map(
            ([key, value], index) => (
              <Table.Row key={index}>
                <Table.Cell collapsing>{referrerLabels[key]}</Table.Cell>
                <Table.Cell style={{ fontWeight: 'bold' }}>{value}</Table.Cell>
              </Table.Row>
            )
          )}
        </Table.Body>
      </Table>
      {formState.values.requests.map((request, requestIndex) => (
        <Table celled striped attached key={requestIndex}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan='2'>
                Request #{requestIndex + 1} details
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {Object.entries(request)
              .filter(([key, value]) => value !== '')
              .map(([key, value], index) => (
                <Table.Row key={index}>
                  <Table.Cell collapsing>
                    {key.includes('studyDates')
                      ? 'Study dates'
                      : requestLabels[key]}
                  </Table.Cell>
                  <Table.Cell style={{ fontWeight: 'bold' }}>
                    {renderValuesColumn(key, value)}
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      ))}
    </Container>
  )
})
